import { IApplicationState } from '../../../types/redux';

export function selectGeoSearch(state: IApplicationState): string {
  const {
    filters: { geoSearch },
  } = state;

  return geoSearch;
}
